import AutomatedReportModal from './AutomatedReportModal.connect'

export default AutomatedReportModal
